declare const __TERRIFIC_ANALYTICS_EVENTS_URL__: string;

export const DEFAULT_ANALYTICS_EVENTS_URL =
  'https://app-terrific-deploy-stage.terrific.live/api/v1/events/pixel';

export const ANALYTICS_EVENTS_URL =
  typeof __TERRIFIC_ANALYTICS_EVENTS_URL__ === 'string'
    ? __TERRIFIC_ANALYTICS_EVENTS_URL__
    : DEFAULT_ANALYTICS_EVENTS_URL;
